// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthContent-base__VtVym{position:relative;display:flex;flex-direction:column;align-items:flex-start;height:var(--size-full);overflow-x:hidden;overflow-y:auto;overflow:hidden auto}@media only screen and (min-width: 64rem){.AuthContent-base__VtVym{flex:none;width:var(--size-96);height:-moz-fit-content;height:fit-content;margin-top:auto;margin-bottom:auto;overflow:hidden}}.AuthContent-componentNavigationContent__F5oro{height:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AuthContent-base__VtVym",
	"componentNavigationContent": "AuthContent-componentNavigationContent__F5oro"
};
export default ___CSS_LOADER_EXPORT___;
